import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Controller, useFormContext } from "react-hook-form";

import {
  Select,
  OptionItem,
  ToggleButton,
} from "@transfr-inc/dashboard-components/forms";
import { RequiredItem } from "@transfr-inc/dashboard-components";

import "./org-disciplines.editor.scss";

export const getCareerOptions = (data) =>
  data?.map((d) => new OptionItem({ id: d.id, text: d.title, data: d }));

const defaultPlaceholder =
  "Select one or more careers for this organization...";

export function OrgTrekCareersEditor({
  data,
  placeholder,
  className,
  name = "careers",
  required = false,
}) {
  const fieldTitle = "Trek Careers";
  const [options, setOptions] = useState();
  const { control, watch, resetField } = useFormContext();
  const hasAllCareers = watch("allCareers");

  useEffect(() => {
    setOptions(getCareerOptions(data));
  }, [data]);

  useEffect(() => {
    resetField(name);
  }, [hasAllCareers]);

  return (
    <div className={clsx("editor-section", className)}>
      <div className="section-title">
        <h2>{required ? <RequiredItem text={fieldTitle} /> : fieldTitle}</h2>
      </div>
      <>
        <Controller
          control={control}
          rules={{
            required: false,
          }}
          name="allCareers"
          render={({ field: { value, onChange } }) => {
            return (
              <div className="universal-access-container">
                <span>Select All</span>
                <ToggleButton value={value} onChange={onChange}></ToggleButton>
              </div>
            );
          }}
        />
        <div className="instructions">
          {hasAllCareers
            ? "Careers will automatically be updated."
            : "New careers will not be automatically added."}
        </div>
        {!hasAllCareers && (
          <Controller
            control={control}
            rules={{
              required,
            }}
            name={name}
            render={({ field: { value, onChange } }) => {
              return (
                <Select
                  selected={value ?? []}
                  placeholder={placeholder ?? defaultPlaceholder}
                  icon={["fa-light", "fa-objects-column"]}
                  onOptionsChange={onChange}
                  className={"product-select"}
                  options={options}
                  searchEnabled
                ></Select>
              );
            }}
          />
        )}
      </>
    </div>
  );
}
